import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TranslateIcon from '@mui/icons-material/Translate';
import { Menu, MenuItem, Typography } from '@mui/material';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- no need for permission check
import Button from '@mui/material/Button';
import { useCallback, useEffect, useState } from 'react';
import { useAuthState, useLocaleState } from 'react-admin';

const localeOptions = [
  { locale: 'en', name: 'English', lang: 'en' },
  { locale: 'fr', name: 'Français', lang: 'fr' },
];

export const CustomLocalesMenuButton = ({ testId }: { testId: string }) => {
  const [locale, setLocale] = useLocaleState();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isOpen = Boolean(anchorEl);

  const handleClick = useCallback((event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleLocaleChange = useCallback(
    (newLocale: string) => {
      setLocale(newLocale);
      handleClose();
    },
    [setLocale, handleClose],
  );

  const currentLocale = localeOptions.find((option) => option.locale === locale);

  const { authenticated } = useAuthState();
  useEffect(() => {
    if (authenticated) {
      return;
    }

    document.documentElement.lang = locale;
  }, [authenticated, locale]);

  return (
    <>
      <Button
        variant="text"
        size="small"
        onClick={handleClick}
        startIcon={<TranslateIcon />}
        endIcon={<ExpandMoreIcon />}
        data-testid={testId}
        sx={{
          textTransform: 'none',
          minWidth: 'auto',
          padding: '4px 8px',
          marginRight: '0 !important',
          backgroundColor: 'action.hover',
          color: 'text.primary',
        }}>
        <Typography variant="body2" lang={currentLocale?.lang || 'en'}>
          {currentLocale?.name || 'English'}
        </Typography>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}>
        {localeOptions.map((option) => (
          <MenuItem
            key={option.locale}
            onClick={() => handleLocaleChange(option.locale)}
            selected={option.locale === locale}
            lang={option.lang} // This adds the lang attribute
            sx={{
              minWidth: 120,
            }}
            data-testid="BoExternalCustomLocalesMenuButton_LocaleMenuItem">
            <Typography variant="body2" lang={option.lang}>
              {option.name}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
